import { ColorPicker, FormSwitch, TextInput } from "@msuite/ui/form";
import { useTranslation } from "@msuite/ui/localization";
import type { CostCenterSchema } from "@msuite/utils/schemas";
import React from "react";
import { useFormContext } from "react-hook-form";

export function CostCenterForm() {
	/** Context */
	const methods = useFormContext<CostCenterSchema>();

	/** Hooks */
	const { t } = useTranslation();

	/** Render */
	return (
		<React.Fragment>
			<TextInput
				control={methods.control}
				name="number"
				label={t("cost_centers.number")}
				placeholder={t("cost_centers.number_placeholder")}
				isRequired
				autoFocus
				data-cy="cost-center-number-input"
			/>
			<TextInput
				control={methods.control}
				name="name"
				label={t("cost_centers.name")}
				placeholder={t("cost_centers.name_placeholder")}
				isRequired
				data-cy="cost-center-name-input"
			/>
			<ColorPicker
				control={methods.control}
				name="color"
				label={t("theme.color")}
				isRequired
			/>
			<FormSwitch
				control={methods.control}
				name="isActive"
				data-cy="cost-center-active-switch"
			>
				{t("cost_centers.is_active")}
			</FormSwitch>
		</React.Fragment>
	);
}
